import script from "./licenze.vue?vue&type=script&setup=true&lang=js"
export * from "./licenze.vue?vue&type=script&setup=true&lang=js"

import "./licenze.vue?vue&type=style&index=0&id=c0024dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0024dc4"]])

export default __exports__